var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({attrs:{"src":_vm.resolvedSrc,"loading":_vm.resolvedLoading,"decoding":_vm.resolvedDecoding,"fetchpriority":_vm.resolvedFetchPriority}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }